import { Text } from 'ui-kit/typography'
import { BuilderHeroDataType } from './builderHeroData'
import classes from './BuilderHero.module.scss'

export const BuilderHeroCard = ({ item }: { item: BuilderHeroDataType }) => {
  const { description, icon } = item

  return (
    <li className={classes.item}>
      <img width={25} height={24} src={icon.src} alt='Icon' />
      <Text size={'lg'}>{description}</Text>
    </li>
  )
}
